import { useState } from 'react';
import styles from './FormField.module.css';

function FormField({ icon, error, label, hasBorder, FormRichTextField, isAuth, children, filter, themeLight, prefix, labelDirection, ...props }) {
    const [isPasswordVisible, setPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible((prev) => !prev);
    };

    let wrapper_class = styles.wrapper;

    if (error) {
        wrapper_class += ' ' + styles.wrapper_error;
    }

    if (props.type === 'password') {
        wrapper_class += ' ' + styles.password;
    }

    if (icon) {
        wrapper_class += ' ' + styles.withIcon + ' ' + styles['withIcon_' + icon];
    }

    if (hasBorder) {
        wrapper_class += ' ' + styles.hasBorder;
    }
    if (isAuth) {
        wrapper_class += ' ' + styles.isAuth;
    }
    if (themeLight) {
        wrapper_class += ' ' + styles.themeLight;
    }
    if (filter) {
        wrapper_class += ' ' + styles.filter;
    }
    if (prefix) {
        wrapper_class += ' ' + styles.withPrefix;
    }

    return (
        <div className={

                filter ?
                labelDirection === 'right' ?
                `${styles.field} ${styles.removeMargin} ${styles.labelRight}` :
                `${styles.field} ${styles.removeMargin}` : 
                
                labelDirection === 'right' ?
                `${styles.field} ${styles.labelRight}` :
                styles.field}


>
            {label && <label htmlFor={props.name} style={{ whiteSpace:labelDirection === 'right' ? 'nowrap' : 'normal' }}>{label}</label>}
            <div className={wrapper_class} >
                {prefix && <span className={styles.prefix}>{prefix}</span>}
                <input
                    {...props}
                    type={isPasswordVisible && props.type === 'password' ? 'text' : props.type}
                    className={prefix ? styles.inputWithPrefix : ''}
                />
                {props.type === 'password' && (
                    <span
                        className={styles.toggleIcon}
                        onClick={togglePasswordVisibility}
                        role="button"
                        aria-label="Toggle password visibility"
                    />
                )}
            </div>
            {error && <p className={styles.error}>{error}</p>}
        </div>
    );
}

export default FormField;
